import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import MainPage from "src/components/Page/MainPage";
import { getContactListSaga } from "src/store/contact/saga";
import { SpesificationDto } from "src/store/web-spesifications/type";
const ContactPage = () => {
  const { t } = useTranslation();
  const [data, setData] = useState<SpesificationDto[]>([]);
  const columns = [
    {
      text: t("Contact.Name"),
      dataField: "Name",
    },
    {
      text: t("Contact.Surname"),
      dataField: "Surname",
    },
    {
      text: t("Contact.Phone"),
      dataField: "Phone",
    },
    {
      text: t("Contact.Email"),
      dataField: "Email",
    },
    {
      text: t("Contact.Message"),
      dataField: "Message",
    },
  ];

  return (
    <React.Fragment>
      <MainPage
        title={t("Contact.PageTitle")}
        metaTag={t("Contact.MetaTag")}
        gridProps={{
          addTitle: t("Contact.AddButton").toString(),
          listData: data,
          columns: columns,
          setDataList: setData,
          action: getContactListSaga,
        }}
      />
    </React.Fragment>
  );
};

export default ContactPage;
